import { Input, InputLeftAddon, InputGroup } from '@chakra-ui/react';

const AddonInput = ({
  label,
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  isRequired,
  compact = false,
}: {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  isRequired?: boolean;
  compact?: boolean;
}) => {
  return (
    <InputGroup size={compact ? 'sm' : 'md'}>
      <InputLeftAddon
        height="auto"
        bg="white"
        color={compact ? '#989898' : 'black'}
        fontSize={compact ? '13px' : '14px'}
        minW={compact ? '110px' : '130px'}
        border={compact ? '2px solid rgba(228,228,228,0.5)' : '2px solid #dddddd80'}
        borderRight="none"
        borderRadius={compact ? '5px 0 0 5px' : undefined}
      >
        {label}{!compact && ':'}{isRequired && <span style={{ color: 'red' }}>*</span>}
      </InputLeftAddon>
      <Input
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onFocus={(e) => onFocus?.()}
        onBlur={(e) => onBlur?.()}
        fontSize={compact ? '13px' : undefined}
        bg={compact ? '#E4E4E480' : undefined}
        border={compact ? '2px solid rgba(228,228,228,0.5)' : undefined}
        borderRadius={compact ? '0 5px 5px 0' : undefined}
      />
    </InputGroup>
  );
};

export default AddonInput;
